<!-- Mails Folder List  -->
<div class="row h-100">
  <p-splitter [panelSizes]="[30, 70]" [minSizes]="[20, 20]" [style]="{ height: '100%' }">
    <ng-template pTemplate>
      <section class="mailsFolders pt-1 super-compos-left-shadow h-100">
        <i-title [text]="'homeCourrier.title' | translate" level="1"
          ><p-dropdown appendTo="body" styleClass="w-100 noBorder viewDropdown" [options]="tabsArrayNewVisual" (onChange)="onChangeNewVisual($event)">
            <ng-template let-item pTemplate="selectedItem">
              <span><i class="{{ item?.icon }} dropdown-icon" style="font-size: 22px; color: #24344b"></i></span>
            </ng-template>
            <ng-template let-cat pTemplate="item">
              <div><i class="{{ cat?.icon }} me-2"></i>{{ cat?.title }}</div>
            </ng-template>
          </p-dropdown></i-title
        >
        @if (mode === 'TDB') {
          <div class="d-flex align-items-center justify-content-center mt-2">
            @if (creationMailChildrenButton?.length > 1) {
              <i-button
                styleClass="green"
                [text]="'homeCourrier.newCourriers' | translate"
                (click)="this.checkOpenMailRights($event)"
                [childrenItems]="creationMailChildrenButton"
                icon="bi bi-plus-circle me-2"
                iconPosition="left"></i-button>
            } @else {
              <i-button
                styleClass="green"
                [text]="'homeCourrier.newCourriers' | translate"
                (click)="this.checkOpenMailRights($event)"
                icon="bi bi-plus-circle me-2"
                iconPosition="left"></i-button>
            }
          </div>
        }

        <div>
          @switch (mode) {
            @case ('TDB') {
              <div class="superbox-list">
                @if (boxes2.length > 0 && boxes3.length === 0) {
                  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 150px)' }" styleClass="custombar1">
                    <app-super-box-list-custom [dragEnabled]="true" [boxArray]="boxes2"></app-super-box-list-custom>
                  </p-scrollPanel>
                }
                @if (boxes2.length > 0 && boxes3.length > 0) {
                  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 150px)' }" styleClass="custombar1">
                    <app-super-box-list-custom [dragEnabled]="true" [boxArray]="boxes3"></app-super-box-list-custom>
                  </p-scrollPanel>
                }
              </div>
            }
            @case ('iBac') {
              <div class="superbox-list">
                @if (boxes2.length > 0 && boxes3.length === 0) {
                  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 150px)' }" styleClass="custombar1">
                    <app-super-box-list-custom [dragEnabled]="true" [boxArray]="boxes2"></app-super-box-list-custom>
                  </p-scrollPanel>
                }
                @if (boxes2.length > 0 && boxes3.length > 0) {
                  <p-scrollPanel [style]="{ width: '100%', height: 'calc(100vh - 150px)' }" styleClass="custombar1">
                    <app-super-box-list-custom [dragEnabled]="true" [boxArray]="boxes3"></app-super-box-list-custom>
                  </p-scrollPanel>
                }
              </div>
            }
            @case ('Kanban') {
              <div></div>
            }
            @case ('Inventory') {
              <div>
                <app-home-courrier-tree (searchParams)="receive_params($event)"></app-home-courrier-tree>
              </div>
            }
          }
        </div>
      </section>
    </ng-template>
    <ng-template pTemplate>
      @if (!isScanMode) {
        <section class="ps-2 pe-2">
          <div>
            @switch (mode) {
              @case ('TDB') {
                <div>
                  @if (courrierScheduler.length <= 0) {
                    <div class="row">
                      <div class="col-md-12 d-flex align-items-center justify-content-center py-4 text-center">
                        <h2 class="custom-h4-title py-4">{{ 'homeCourrier.noCourriersToProcess' | translate }}</h2>
                      </div>
                      <div class="col-md-12 d-flex align-items-center justify-content-center py-4">
                        <img src="./assets/img/undraw_coffee_break_j3of.svg" width="45%" [alt]="'noActionCat' | translate" class="img-fluid" />
                      </div>
                    </div>
                  }
                  @if (courrierScheduler.length > 0) {
                    <div class="">
                      <div class="h-100">
                        <p-table
                          #dt
                          [value]="courrierScheduler | sort: 'dateEcheance' : 'ASC'"
                          class="super-table super-table-breakWhiteSpaces"
                          tableStyleClass="super-table super-table-breakWhiteSpaces"
                          styleClass="p-datatable-striped"
                          [scrollable]="true"
                          scrollHeight="85vh"
                          [paginator]="true"
                          [rows]="20"
                          [totalRecords]="courrierScheduler.length"
                          [globalFilterFields]="[
                            'objet',
                            'objetFormatedLabel',
                            'typeEntrantSortantLabel',
                            'statutIdLabel',
                            'dateEcheanceLabel',
                            'serviceProprietaire.description',
                          ]"
                          [resizableColumns]="true"
                          responsiveLayout="scroll">
                          <ng-template pTemplate="caption">
                            <div class="d-flex align-items-center justify-content-between">
                              <div>
                                <span class="p-input-icon-left ms-auto">
                                  <i class="pi pi-search"></i>
                                  <input
                                    pInputText
                                    class="w-100"
                                    type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    [placeholder]="'quickSearch' | translate" />
                                </span>
                              </div>
                              <div class="d-flex">
                                <h3 class="echeancierTitle me-3">{{ 'homeCourrier.courriersSchedule' | translate }}</h3>
                                <i
                                  [pTooltip]="'homeCourrier.youCanChangeTheStatutByClickingOnItAndSelectingAnotherOne' | translate"
                                  class="bi bi-info-circle"></i>
                              </div>
                              <p-dropdown
                                [(ngModel)]="sizeChoice"
                                [options]="sizeOfPages"
                                (onChange)="pageSizeChange()"
                                inputStyleClass="w-100"
                                styleClass="dropdown-inforius"
                                appendTo="body">
                              </p-dropdown>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              @for (col of schedulerColumns; track col; let i = $index) {
                                <th [id]="col.field" [pSortableColumn]="col.field" pResizableColumn>
                                  {{ col.header }}
                                  <p-sortIcon [field]="col.filterableSortableLabel"></p-sortIcon>
                                  <p-columnFilter type="text" [field]="col.filterableSortableLabel" display="menu"></p-columnFilter>
                                </th>
                              }
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-ri="rowIndex" let-editing="editing">
                            <tr [pEditableRow]="rowData">
                              <td (click)="redirectToCourrierFich(rowData.id)">
                                <div class="tdApList cursor--pointer" [pTooltip]="rowData.objet">{{ rowData.objetFormatedLabel }}</div>
                              </td>
                              <td>
                                <div class="tdApList">{{ rowData.typeEntrantSortantLabel }}</div>
                              </td>
                              <td class="tdApList cursor--pointer" (click)="openChangeStatutEcheancier(rowData)">
                                <div
                                  [pTooltip]="rowData.statutIdLabel"
                                  class="p-2 cursor--pointer"
                                  [style.background-color]="rowData.statutDatas?.color"
                                  [style.color]="rowData.statutDatas?.textColor">
                                  {{ rowData.statutIdLabel }}
                                </div>
                              </td>
                              <td>{{ rowData.dateEcheanceLabel }}</td>
                              <td>
                                <span [pTooltip]="rowData.serviceProprietaireLabel">{{ rowData.serviceProprietaireLabel }}</span>
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  }
                </div>
              }
              @case ('iBac') {
                <div>
                  <div class="mb-4">
                    <i-title [text]="'homeCourrier.myBacs' | translate" level="1"></i-title>
                  </div>
                  <div class="row mt-3 mb-4">
                    @for (bac of bacs; track bac) {
                      <div class="col-md-4 mb-3">
                        @if (bac?.bac?.nePasUtilise === false) {
                          <div class="ibac_box" (click)="loadBac(bac)">
                            <div class="ibac_box__icon">
                              <img src="./assets/img/drawer.svg" width="70" class="img-fluid" alt="" />
                              <span class="ibac_box__number"> {{ bac?.totalCourriers }} </span>
                            </div>
                            <h3 class="ibac_box__title">{{ bac?.bac?.name }}</h3>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              @case ('Inventory') {
                <div>
                  <app-home-courrier-tree-tbl [searchParams]="searchFilesParams"></app-home-courrier-tree-tbl>
                </div>
              }
            }
          </div>
        </section>
      }
    </ng-template>
  </p-splitter>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">{{ 'loading' | translate }}</p>
</ngx-spinner>

<p-sidebar
  [(visible)]="displayKanban"
  styleClass="sidebar-kanban"
  [fullScreen]="true"
  appendTo="body"
  (onHide)="mode = 'TDB'; searchFilesParams = null">
  <app-home-courrier-kanban [items]="items" [loaded]="displayKanban"></app-home-courrier-kanban>
</p-sidebar>

<p-confirmDialog
  key="courrierFicheForm"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  header="Confirmation"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

<p-dialog
  [(visible)]="openChangeStatutEcheancierModal"
  [closable]="true"
  (onClose)="closeModalChangeStatutEcheancierModal()"
  styleClass="super-compos-modal-content modal-scss"
  appendTo="body"
  [style]="{ width: '50vw' }">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'status.update' | translate }}</h5>
    </div>
  </p-header>
  <form class="row" [formGroup]="formChangeStatutEcheancier">
    <div class="col-md-12 mb-3 p-fluid">
      <label class="input-label"> {{ 'homeCourrier.mailFileName' | translate }} </label>
      <div>{{ chosenEcheancierFicheCourrier?.objet }}</div>
    </div>
    <div class="col-md-12 mb-3 p-fluid">
      <label class="input-label"> {{ 'status.title' | translate }} </label>
      <p-dropdown
        id="changeStatusModalId"
        styleClass="w-100"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        appendTo="body"
        [options]="schedulerStatusList | sort: 'ordre' : 'ASC'"
        [filter]="true"
        [placeholder]="'status.change' | translate"
        [showClear]="true"
        formControlName="statutId">
        <ng-template let-item pTemplate="selectedItem">
          <span [ngStyle]="{ color: item?.textColor, 'background-color': item?.color }">{{ item?.label }}</span>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <span class="changeStatusModalId__label" [style.background-color]="item.color" [style.color]="item.textColor" [pTooltip]="item.label">{{
            item?.label
          }}</span>
        </ng-template>
      </p-dropdown>
    </div>
  </form>
  <div class="d-flex justify-content-end">
    <i-button styleClass="red me-3" [text]="'cancel' | translate" (click)="closeModalChangeStatutEcheancierModal()"></i-button>
    <i-button styleClass="green" (click)="changeGlobalStatus()" [text]="'confirm' | translate"></i-button>
  </div>
</p-dialog>
